<template>
  <div id="ticketManage">

    <custom-table ref="customTable" has-organization="true" :customOptions="customOptions" :columns="columns"
                  addText="票据领取" @addFn="addFn" maxHeight="650">
      <template slot="table-operation">
        <el-table-column label="操作" width="100" fixed="right">
          <div slot-scope="{row}" class="custom-action">
            <el-button type="text" size="small" @click="deleteClick(row)">
              {{ row.remainingNum == 0 ? '删除' : '缴销' }}
            </el-button>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{item, row}">
        <div v-if="item.prop == 'created'">{{ row.created | filterTime }}</div>
        <span v-else>{{ row[item.prop] }}</span>
      </template>
    </custom-table>

    <!-- 领取 -->
    <el-dialog :visible.sync="dialogVisible" title="票据领取" @close="$refs.form.resetFields();selectPushRow={}"
               width="30%">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="机构名称" prop="organizationId">
          <el-select :disabled="form.id ? true : false" v-model="form.organizationId" filterable
                     v-if="mixinUserInfo && mixinUserInfo.organizationType == 1">
            <el-option v-for="(item, i) in organizations" :key="i" :value="item.id" :label="item.name">
            </el-option>
          </el-select>
          <span v-else>{{ organizations && organizations[0] && organizations[0].name }}</span>
        </el-form-item>

        <el-form-item label="领票员" prop="receiveAdminId">
          <el-select v-model="form.receiveAdminId" :disabled="!form.organizationId" filterable>
            <el-option v-for="(item, i) in admins" :key="i" :value="item.id" :label="`${item.name} - ${item.phone}`">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="selectPushRow.ticketCurrentNo?'开始票号':'库存票据'" prop="ticketCurrentNo">
          <el-button type="text" size="small" :disabled="!form.organizationId" @click="openPush()"
                     style="position:relative;top:-2px">{{ selectPushRow.ticketCurrentNo || '选择票据' }}
          </el-button>
          <!-- <div v-if="selectPushRow.id">
            {{selectPushRow.id}}
          </div> -->
        </el-form-item>
        <el-form-item label="领取张数" prop="ticketNum">
          <el-input v-model="form.ticketNum" v-input-filter="{ min: 1, max: 999999, precision: 0 }"
                    :disabled="!selectPushRow.ticketCurrentNo" @input="ticketNumChange($event)"></el-input>
        </el-form-item>
        <el-form-item label="结束票号" prop="ticketEndNo">
          <el-input :value="form.ticketEndNo" disabled>
          </el-input>
        </el-form-item>
        <el-form-item style="margin-top: 50px; text-align: right;">
          <el-button @click=" dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveClick" :loading="loading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 票据选择 -->
    <el-dialog :visible.sync="dialogVisible2" title="入库票据" width="75%" append-to-body>
      <custom-table ref="customTable2" :has-organization="false" :customOptions="customOptions2" :columns="columns2"
                    maxHeight="500">
        <template slot="table-operation">
          <el-table-column label="操作" width="100" fixed="right" v-slot="{row}">
            <el-button type="text" size="small" @click="selectPush(row)">选择</el-button>
          </el-table-column>
        </template>
        <template slot-scope="{item, row}">
          <div v-if="item.prop == 'created'">{{ row.created | filterTime }}</div>
          <span v-else>{{ row[item.prop] }}</span>
        </template>
      </custom-table>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: "ticketManage",

  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/ticket/receive',
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {type: "input", field: "ticketStartNo", name: "开始票号", value: ""},
          {type: "input", field: "ticketEndNo", name: "结束票号", value: ""},
          {type: "input", field: "receiveAdminName", name: "领票员", value: ""},
          {
            type: "select",
            field: "remainingNumFlag",
            name: "剩余张数",
            value: "1",
            option: [
              {label: '未用完', value: '1'},
              {label: '已用完', value: '2'}
            ],
          },
        ]
      },
      columns: [
        {prop: 'receiveAdminName', label: '领票员'},
        {prop: 'created', label: '领票时间'},
        {prop: 'ticketStartNo', label: '开始票号'},
        {prop: 'ticketEndNo', label: '结束票号'},
        {prop: 'ticketCurrentNo', label: '当前票号'},
        {prop: 'ticketNum', label: '领取张数'},
        {prop: 'remainingNum', label: '剩余张数'},
        {prop: 'adminName', label: '操作员'},
      ],

      dialogVisible: false,
      admins: [],
      form: {
        organizationId: null,
        receiveAdminId: null,
        ticketCurrentNo: null,
        ticketNum: null,
        ticketEndNo: null
      },
      rules: {
        organizationId: [{required: true, message: '请选择机构名称'}],
        receiveAdminId: [{required: true, message: '请选择领票员'}],
        ticketNum: [{required: true, message: '请输入领取张数'}],
        ticketCurrentNo: [{required: true, message: '请选择票据'}],
        ticketEndNo: [{
          required: true,
          validator: (rule, value, callback) => {
            if (Number(value) > this.selectPushRow.ticketEndNo) {
              callback(new Error('结束票号不能超出票据的结束票号'))
            } else {
              callback()
            }
          }
        }]
      },
      loading: false,

      dialogVisible2: false,
      customOptions2: {
        url: '/api/v1/manage/ticket/storage',
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
          remainingNumFlag: 1,
          organizationId: null
        }
      },
      columns2: [
        {prop: 'ticketStartNo', label: '开始票号'},
        {prop: 'ticketEndNo', label: '结束票号'},
        {prop: 'ticketCurrentNo', label: '当前票号'},
        {prop: 'storageNum', label: '入库张数'},
        {prop: 'remainingNum', label: '剩余张数'},
        {prop: 'created', label: '入库时间', width: 150},
        {prop: 'adminName', label: '入库员'},
        {prop: 'remark', label: '备注'},
      ],
      selectPushRow: {}
    }
  },
  async created() {
    await this.mixinOrganizations()
    if (!this.id && this.mixinUserInfo && this.mixinUserInfo.organizationType == 2) {
      if (this.organizations && this.organizations[0] && this.organizations[0].id) {
        this.organizationId = this.organizations[0].id
      }
    }
  },
  methods: {
    /* 接口调用-获取角色列表 */
    async getAdmins() {
      let url = '/api/v1/manage/admin'
      let data = await this.$axios.get(url, {page: 1, size: 999, organizationId: this.form.organizationId})
      if (data && data.code == 1) {
        this.admins = data.data;
      }
    },

    /* 打开入库票据 */
    openPush() {
      this.customOptions2.params.organizationId = this.form.organizationId;
      this.customOptions2.params.page = 1;
      this.dialogVisible2 = true;
      this.$nextTick(() => {
        this.$refs.customTable2.listFn();
      })
    },

    /* 选择入库票据 */
    selectPush(row) {
      this.selectPushRow = row;
      this.dialogVisible2 = false;
      this.form.ticketCurrentNo = row.ticketCurrentNo;
      this.form.ticketNum = null;
      this.ticketNumChange(0);
    },

    /* 领取张数更改 */
    ticketNumChange(e) {
      console.log(e, 1111);
      if (e > 0) {
        this.form.ticketEndNo = Number(this.form.ticketCurrentNo) + Number(e) - 1
        let num = String(this.selectPushRow.ticketEndNo).length - String(this.form.ticketEndNo).length
        let str = ''
        for (let i = 0; i < num; i++) {
          str += '0'
        }
        this.form.ticketEndNo = str + String(this.form.ticketEndNo)

      } else {
        this.form.ticketEndNo = null;
      }
    },

    /* 新增 */
    addFn() {
      this.form.organizationId = this.mixinUserInfo.organizationId;
      this.getAdmins();
      this.dialogVisible = true;
    },

    /* 保存 */
    async saveClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postFn();
        } else {
          this.$message.warning('请检查表单数据是否输入正确！');
          return false;
        }
      });
    },

    /* 提交 */
    async postFn() {
      this.loading = true;
      let url = '/api/v1/manage/ticket/receive';
      let params = this.$utils.deepCopyFn(this.form);
      params.storageId = this.selectPushRow.id;
      params.ticketStartNo = this.selectPushRow.ticketCurrentNo;
      params.receiveAdminName = this.admins.find(item => item.id == this.form.receiveAdminId).name
      let data = await this.$axios.post(url, params);
      this.loading = false;
      if (data && data.code == 1) {
        this.dialogVisible = false;
        this.$message.success('保存成功！')
        this.$refs.customTable.listFn();
      }
    },

    /* 删除 */
    deleteClick(row) {
      let url = `/api/v1/manage/ticket/receive${row.remainingNum > 0 ? '/cancellation' : ''}`
      this.$confirm(`确认要${row.remainingNum > 0 ? '缴销' : '删除'}该记录吗?`, `${row.remainingNum > 0 ? '缴销' : '删除'}提示`).then(async () => {
        let data = await this.$axios[row.remainingNum > 0 ? 'put' : 'delete'](url, {id: row.id})
        if (data && data.code == 1) {
          this.$message.success(`${row.remainingNum > 0 ? '缴销' : '删除'}成功`)
          this.$refs.customTable.listFn()
        }
      })
    }
  }
}
</script>

